import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getItem } from '../utils/localStorage';

function PrivateRoutes () {
  const userData = getItem('user');

  return (
      !!userData ? <Outlet /> : <Navigate to="/login" />
    );
}

export default PrivateRoutes;
